import { render, staticRenderFns } from "./fake_baggage.vue?vue&type=template&id=2fbf998a&"
import script from "./fake_baggage.vue?vue&type=script&lang=js&"
export * from "./fake_baggage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260812101347/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fbf998a')) {
      api.createRecord('2fbf998a', component.options)
    } else {
      api.reload('2fbf998a', component.options)
    }
    module.hot.accept("./fake_baggage.vue?vue&type=template&id=2fbf998a&", function () {
      api.rerender('2fbf998a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/desktop/itineraries/internal/fake_baggage.vue"
export default component.exports